import type { GetStaticPaths, GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/global';
import {
	DEFAULT_PAGE_INDEX,
	DEFAULT_PER_PAGE,
	DEFAULT_PER_PAGE_GET_ALL,
} from 'src/constants/pagination';
import { IArticleByGroupDetail, ICategoryByGroupDetail } from 'src/interface';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { actionGetArticleByCategorySlug } from 'src/redux/actions/articleByGroup';
import { actionGetSubCategoryByParentCategorySlug } from 'src/redux/actions/categoryByGroup';
import ibuAnakSEO from 'src/utils/dummy/SEO/ibu-anak';

const HeadC = dynamic(() => import('src/components/Head'));
const CategoryPageLayout = dynamic(() => import('src/components/Layout/Category'));
const SubCategory = dynamic(() => import('src/containers/Category'));

const SubCategoryPage = (props: any) => {
	const { router } = props;
	const sub = router?.query?.sub || '';
	const metaTitle = ibuAnakSEO[sub] && ibuAnakSEO[sub].title;
	const metaDescription = ibuAnakSEO[sub] && ibuAnakSEO[sub].description;

	return (
		<>
			<HeadC title={metaTitle} description={metaDescription} />
			<CategoryPageLayout adSource="ibu-anak-category" adTarget={[['channel', ['ibu-anak', sub]]]}>
				<SubCategory />
			</CategoryPageLayout>
		</>
	);
};

export const getStaticPaths: GetStaticPaths = () => {
	return {
		paths: [],
		fallback: 'blocking',
	};
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
	(store) => async (ctx: any) => {
		let isError: boolean = false;
		const query = ctx.params;
		const categorySlug = 'ibu-anak';
		const subCategorySlug = query.sub;

		try {
			await store.dispatch(actionGetMenu());
			await store.dispatch(actionGetFooterMenu());

			await store.dispatch(
				actionGetArticleByCategorySlug(subCategorySlug, {
					page: DEFAULT_PAGE_INDEX,
					per_page: DEFAULT_PER_PAGE,
					should_show_headline: true,
				}),
			);
			await store.dispatch(
				actionGetSubCategoryByParentCategorySlug(categorySlug, {
					page: DEFAULT_PAGE_INDEX,
					per_page: DEFAULT_PER_PAGE_GET_ALL,
					orderby: 'name',
					order: 'asc',
				}),
			);
		} catch (err: any) {
			if (err?.status === 400) {
				isError = true;
			} else {
				throw err;
			}
		}

		const subCategories: ICategoryByGroupDetail[] = store.getState().categoryByGroup.subCategories;
		const category = subCategories.find(
			(sc) => sc.slug === subCategorySlug,
		) as ICategoryByGroupDetail;

		const article: IArticleByGroupDetail[] =
			store.getState().articleByGroup.articleByCategory?.data?.records;

		if ((!category || !article) && isError) return { notFound: true };

		return {
			props: {
				card: true,
				isWhiteBackground: true,
				pageHeaderContent: {
					title: category.name,
					breadcrumbs: [
						{ label: 'Ibu Dan anak', navigatePath: '/ibu-anak' },
						{ label: category.name },
					],
				},
			},
			revalidate: g.REVALIDATE_EXP_ARTICLE,
		};
	},
);

export default SubCategoryPage;
